const url = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
// const url = 'http:' + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
let base = url.replace(':3000', '');
base = base.replace(':3001', '');
base = base.replace(':3002', '');

let API_URL = base + '/api';
let SITE = base;
let BASENAME = '/';
// if (window.location.hostname === '192.168.2.120') {
//     API_URL = base + '/serfin/api';
//     SITE = base + '/serfin';
//     BASENAME = '/serfin';
// }
if (window.location.hostname === '192.168.2.120') {
    API_URL = base + '/api';
    SITE = base + '/';
    BASENAME = '/';
}
if (window.location.hostname === 'localhost' || window.location.hostname === '192.168.1.86') {
    API_URL = base + '/apiserfinweb';
    BASENAME = '/serfin.com.py';
}

const CONFIG = {
    ID: 'serfin',
    APP_NAME: 'serfin',
    SITE: SITE,//sitio web
    HOST: SITE,//production (copiar y pegar en package.json --> homepage)
    BASENAME: '/',//subdirectorio
    API_URL: 'https://www.serfin.com.py/api',//api
    LOGS: true
}

// const CONFIG = {
//     ID: 'serfin',
//     APP_NAME: 'serfin',
//     SITE: SITE,//sitio web
//     HOST: SITE,//production (copiar y pegar en package.json --> homepage)
//     BASENAME: BASENAME,//subdirectorio
//     API_URL: API_URL,//api
//     LOGS: true
// }
export default CONFIG;